import React from 'react';
import { useDispatch } from 'react-redux';
import { filterDeliveryExpedition } from '../../actions/deliveryNotes';
import { storeStartLoading } from '../../actions/storeCrud';
import moment from 'moment';

export const BtnDeliveryExpedition = (props) => {

    const dispatch = useDispatch();
    let dateEnd = moment().format("yyyy-MM-DD");
    let dateIni = moment();
    const intervalMovement = window.APP_CONFIG.daymovement;

    dateIni = dateIni.subtract(intervalMovement, "days");
    dateIni = dateIni.format("yyyy-MM-DD");

    const deliveryE = {
        store_id: props.store !== undefined ? props.store :'',
        expcode: '',
        expsdate: dateIni,
        expedate: dateEnd,
    }

    const handleClick = () => {
        dispatch(storeStartLoading());
        dispatch(filterDeliveryExpedition(deliveryE));
    }

    return (
        <button className="btn btn-danger margin_right_envelope btnColor" props={props} onClick={handleClick}>
            <i className="fas fa-user-alt icon"> </i>
            <span className="navbar-brand user">
                EXPEDICIONES / SALIDAS
            </span>
        </button>
    )
}
